import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CompanyTypeEnum, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { ExporterDataInput } from '@gtpl/shared-models/logistics';
export class UnitCodeDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "department id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Department Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({ message: "Unitcode id should not be empty" })
  @IsAlphanumeric()
  @IsOptional()
  unitcodeId: number;
  @ApiProperty()
  @MaxLength(15, { message: "Unitcode Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Department name should be only alpha numeric" })
  unitcodeName: string;

  @ApiProperty({ enum: Object.values(UnitTypeEnum) })
  @IsNotEmpty()
  @IsEnum(UnitTypeEnum)
  plantType: UnitTypeEnum;

  @ApiProperty()
  @MaxLength(15, { message: "village Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Village name should be only alpha numeric" })
  villageName: string;

  @ApiProperty()
  @MaxLength(15, { message: "Mandal Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Mandal name should be only alpha numeric" })
  mandalName: string;

  @ApiProperty()
  @MaxLength(15, { message: "Distirct Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Distirct name should be only alpha numeric" })
  distirctName: string;

  @ApiProperty()
  @MaxLength(15, { message: "State Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "State name should be only alpha numeric" })
  stateName: string;

  @ApiProperty()
  @MaxLength(15, { message: "Country name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Country name should be only alpha numeric" })
  countryName: string;

  @ApiProperty()
  @MaxLength(15, { message: "FDA REG Number allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "FDA REG Number should be only alpha numeric" })
  fdaRegNumber: string;

  @ApiProperty()
  @MaxLength(15, { message: "FEI Number allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "FEI Number should be only alpha numeric" })
  feiNumber: string;

  @ApiProperty()
  @MaxLength(15, { message: "Short Key allows maximum 50 characters" })
  @IsNotEmpty()
  shortKey: string;

  @ApiProperty()
  @MaxLength(50, { message: "Bap no allows maximum 50 characters" })
  @IsNotEmpty()
  bapNo: string;

  @ApiProperty()
  @MaxLength(50, { message: "Approval no allows maximum 50 characters" })
  @IsNotEmpty()
  approvalNo: string;

  @ApiProperty()
  @MaxLength(50, { message: "ASC no allows maximum 50 characters" })
  @IsNotEmpty()
  ascNo: string;

  @ApiProperty()
  @MaxLength(50, { message: "Walmart ID allows maximum 50 characters" })
  @IsNotEmpty()
  walmartId: string;

  @ApiProperty()
  @MaxLength(50, { message: "Fishin approval no allows maximum 50 characters" })
  @IsNotEmpty()
  fishInapprovalNo: string;

  @ApiProperty()
  @MaxLength(50, { message: "Kroger no allows maximum 50 characters" })
  @IsNotEmpty()
  krogerNo: string;

  @ApiProperty()
  @MaxLength(15, { message: "Unitcode Name allows maximum 50 characters" })
  @IsNotEmpty()
  postalCode: string;

  @ApiProperty()
  @MaxLength(15, { message: "Unitcode Name allows maximum 50 characters" })
  @IsNotEmpty()
  plantCode: string;



  @ApiProperty()
  isActive: boolean;

  createdAt: Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
  createdUser: string;

  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
  updatedUser: string;

  @ApiProperty()
  versionFlag: number;

  
  @ApiProperty()
  company: String;

  @ApiProperty()
  companyId: number;

}


